import React from 'react';
import { IconButton } from '@chatui/core';
import { useHistory, useLocation } from "react-router-dom";

const HeadeNavbar = props => {
  let history = useHistory();
  let location = useLocation();

  return (
    <div className="ChatApp">
      <div className="Navbar">
        <div className="Navbar-left">
          {props.myButton ? (props.close ?
            <IconButton icon="close" size="lg" color="primary" onClick={() => { window.location.replace(`${window.location.origin}/closeWin`) }} /> :
            <IconButton icon="chevron-left" size="lg" color="primary" onClick={() => { history.push({ pathname: '/', search: location.search }) }} />
          )
            : <IconButton icon="chevron-left" size="lg" color="primary" onClick={() => { history.goBack() }} />}
        </div>
        <div className="Navbar-main">
          <div className="Navbar-title">
            {props.title}
          </div>
        </div>
        <div className="Navbar-right">
          {props.listButton && <IconButton icon="home" size="lg" color="primary" onClick={() => { history.push({ pathname: '/workOrderList', search: location.search }) }} />}
          {props.myButton && <IconButton icon="edit" size="lg" color="primary" onClick={() => { history.push({ pathname: '/myWorkOrder', search: location.search }) }} />}
        </div>
      </div>
      <div className="MessageContainer">
        <div className="PullToRefresh">
          <div className="PullToRefresh-inner">
            <div className="PullToRefresh-content">
              {props.children}
            </div>
          </div>
        </div>
      </div>
      <div className="ChatFooter"></div>
    </div>
  );
};

export default HeadeNavbar;
